import apiClient from "./axios"

export const getAccounts = async (params = {}) => {
  const { data } = await apiClient.get("/accounts", { params })
  return data
}

export const getAccount = async id => {
  const { data } = await apiClient.get(`/accounts/${id}`)
  return data
}

export const createAccount = async payload => {
  const { data } = await apiClient.post("/accounts", payload)
  return data
}

export const updateAccount = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/accounts/${id}`, payload)
  return data
}

export const deleteAccount = async id => {
  const { data } = await apiClient.delete(`/accounts/${id}`)
  return data
}

export const getAccountBalance = async id => {
  const { data } = await apiClient.get(`/accounts/${id}/balance`)
  return data
}
